export const USER_ACTIONS_TBW = {
    // View/capability
    VIEW_TUTORIAL_BUILDER_WEB: 'view-tutorial-builder-web',
    MANAGE_OWN_TUTORIAL: 'manage-own-tutorial',
    READ_TUTORIAL: 'read-tutorial',

    // Workflow
    SUBMIT_AS_AUTHOR: 'submit-as-author',
    SUBMIT_AS_CURATOR: 'submit-as-curator',
    APPROVE_AS_CURATOR: 'approve-as-curator',
    APPROVE_AS_QE: 'approve-as-qe',
    APPROVE_AS_LOCQE: 'approve-as-locqe',
    REJECT_AS_CURATOR: 'reject-as-curator',
    REJECT_AS_QE: 'reject-as-qe',
    ASSIGN_TO_CURATOR: 'assign-to-curator',
    MOVE_TO_REVIEW: 'move-to-review',
    CREATE_NEW_VERSION: 'create-new-version',
    REFRESH_LOCALIZATION: 'refresh-localization',

    // Dashboard section visibility (list queries)
    LIST_TUTORIALS_AS_AUTHOR: 'list-tutorials-as-author',
    LIST_TUTORIALS_AS_CURATOR: 'list-tutorials-as-curator',
    LIST_TUTORIALS_AS_QE: 'list-tutorials-as-qe',
    LIST_TUTORIALS_AS_LOCQE: 'list-tutorials-as-locqe',
    LIST_TUTORIALS_AS_PRODUCTION: 'list-tutorials-as-production',
    LIST_TUTORIALS_AS_READONLY: 'list-tutorials-as-readonly',
};

export default USER_ACTIONS_TBW;
